import React, { useState } from 'react'
import List from './List'
import AddDocumentMain from './DocumentConfigurations/Main'
import SettingsIcon from '@mui/icons-material/Settings'
import ListIcon from '@mui/icons-material/List';
import BackLogo from '../../../../../images/rewampimages/Chevron.png'

export default function Main({ pageViewHandler }) {
    const [tab, setTab] = useState("list")
    const [editData,setEditData] =useState({})

    const handleTab = (type) => {
        setTab(type)
    }

    const handleEdit=(data)=>{
setEditData(data)
setTab("config")
    }

    return (
        <>
            <div className="container-fluid details-new fixed-top"  >
                <div className="row details-new-tab-div" style={{ display: 'flex', justifyContent: 'end' }}>
                    <div className="col-sm-6 col-xs-12 " style={{ marginTop: '15px' }}>
                        <img onClick={(e) => pageViewHandler(e, 'landingPage')} style={{ cursor: 'pointer' }} src={BackLogo} width={'30px'} /> <button style={{ color: '#1D3557', fontWeight: '700' }} onClick={(e) => pageViewHandler(e, 'landingPage')} >Back</button>
                    </div>

                    <div className=" col-lg-6 col-xs-12" style={{ fontSize: '10px', display: 'flex', justifyContent: 'end' }}>


                        <div className="btn-group-new">


                            <button className={(tab === 'list') ? "active" : ""} onClick={(e) => handleTab('list')}><ListIcon style={{ fontSize: '27px' }} /><br />Document List</button>
                            <button className={(tab === 'config') ? "active" : ""} onClick={(e) => handleTab('config')}><SettingsIcon style={{ fontSize: '27px' }} /><br />Document Configuration</button>
                        </div>

                    </div>
                </div>
            </div>
            {
                tab == "list" ?
                    <List handleEdit={handleEdit}/>
                    : ''}
            {
                tab == "config" ?
                    <AddDocumentMain editData={editData}/>
                    : ''}
        </>
    )
}
